import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from '../../../services/auth.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent {
  $authError = signal('');
  private authService = inject(AuthService);
  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    officeName: new FormControl(''),
    contactData: new FormControl(''),
  });

  onSignup() {
    this.$authError.set('');
    this.form.markAllAsTouched();
    if (
      this.form.controls.email.valid &&
      this.form.controls.password.valid &&
      this.form.controls.email.value !== undefined
    ) {
      this.authService
        .signUp(
          this.form.controls.email.value!.toString(),
          this.form.controls.password.value!.toString(),
          this.form.controls.officeName.value?.toString(),
          this.form.controls.contactData.value?.toString()
        )
        .catch(error => {
          console.log('An error occurred', { ...error });
          this.$authError.set(error.code);
        });
    }
  }
}
